import React, { useMemo, useState } from 'react';
import * as appSelectors from 'app/state/app/app-selectors';
import { paymentMethodType } from 'common/constants';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

import { Check } from '../pay-by-check/check';
import { PaymentInfoText } from '../shared-styles';
import { ACH } from './ach';
import { Card } from './card';
import appSettings from '../../../../../app-settings.json';

const HEARTLAND_URL = 'https://js.globalpay.com/3.0.12/globalpayments.js';

export const Heartland = (props) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  const handleChangeClientState = (newState, addedTags) => {
    if (addedTags && addedTags.scriptTags) {
      const foundScript = addedTags.scriptTags.find(
        ({ src }) => src === HEARTLAND_URL,
      );
      if (foundScript) {
        foundScript.addEventListener(
          'load',
          () => {
            if (window.GlobalPayments) {
              window.GlobalPayments.configure({
                publicApiKey: appSettings.heartlandApiKey,
              });

              setScriptLoaded(true);
            }
          },
          {
            once: true,
          },
        );
      }
    }
  };

  const activePaymentMethodTab = useSelector(
    appSelectors.activePaymentMethodTab,
  );
  
  const paymentForm = useMemo(() => {
    if (!scriptLoaded) {
      return null;
    }

    switch (activePaymentMethodTab) {
      case paymentMethodType.CREDIT_CARD:
        return <Card {...props} />;
      case paymentMethodType.ACH:
        return <ACH {...props} />;
      case paymentMethodType.CHECK:
        return <Check />;
      default:
        return null;
    }
  }, [scriptLoaded, activePaymentMethodTab, props]);

  return (
    <>
      <Helmet onChangeClientState={handleChangeClientState}>
        <script src={HEARTLAND_URL} type="text/javascript" />
      </Helmet>
      <PaymentInfoText>{paymentForm}</PaymentInfoText>
    </>
  );
};
